module.exports = __webpack_public_path__ + "img/icon-dropdown-black.8e9cf5ef.svg";